import { render, staticRenderFns } from "./contratante.vue?vue&type=template&id=b52b780e&scoped=true"
import script from "./contratante.vue?vue&type=script&lang=js"
export * from "./contratante.vue?vue&type=script&lang=js"
import style0 from "./contratante.vue?vue&type=style&index=0&id=b52b780e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52b780e",
  null
  
)

export default component.exports